import { Card, CircularProgress } from "@mui/material";
import React from "react";

const Loader = () => {
  return (
    <Card
      sx={{
        height: "500px",
        width: "100%",
        display: "grid",
        placeItems: "center",
        mt: "20px",
        mr: "90px",
      }}
      elevation={3}
    >
      <CircularProgress size={50} />
    </Card>
  );
};

export default Loader;
